export const ACCREDITATION_1_CONSTANTS = {
    DEFAULT_ROW: {
      id: "1",
      meta_logo: "",
      meta_alt_image: "Accreditation logo",
      meta_description: "Sample accreditation description",
      meta_priority: 1,
      meta_description_text_color: "#000000",
      meta_status: true,
    },
  
    ACCREDITATION_FIELDS_CONFIG: [
      {
        fieldName: "title",
        label: "Accreditation Title",
        value: "Our Accreditations",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Accreditation Title",
        required: false,
        defaultValue: "Our Accreditations",
      },
      {
        fieldName: "title_text_color",
        label: "Title Text Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter title text color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "sub_title",
        label: "Sub Title",
        value: "Recognized Excellence",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Sub Title",
        required: false,
        defaultValue: "Recognized Excellence",
      },
      {
        fieldName: "sub_title_text_color",
        label: "Sub Title Text Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter sub title text color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "background_color",
        label: "Section Background Color",
        value: "#FFFFFF",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter section background color (e.g., #FFFFFF)",
        required: false,
        defaultValue: "#FFFFFF",
      },
      {
        fieldName: "is_swipe",
        label: "Enable Swipe",
        value: true,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable Swipe",
        required: false,
        defaultValue: true,
      },
      // {
      //   fieldName: "slide_frequency",
      //   label: "Slide Frequency",
      //   value: 5000,
      //   valueType: "number",
      //   filedType: "INPUT",
      //   placeholder: "Enter Slide Frequency (ms)",
      //   required: true,
      //   defaultValue: 5000,
      // },
      {
        fieldName: "status",
        label: "Accreditation Status",
        value: false,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable Accreditation",
        defaultValue: false,
      },
      {
        fieldName: "left_navigation_icon",
        label: "Left Navigation Icon",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Enter left navigation icon name or URL",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "left_navigation_icon_alt",
        label: "Left Navigation Icon Alt Text",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter alt text for left navigation icon",
        required: false,
        defaultValue: "Left navigation",
      },
      {
        fieldName: "right_navigation_icon",
        label: "Right Navigation Icon",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Enter right navigation icon name or URL",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "right_navigation_icon_alt",
        label: "Right Navigation Icon Alt Text",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter alt text for right navigation icon",
        required: false,
        defaultValue: "Right navigation",
      },
      {
        fieldName: "load_more_text",
        label: "Load More Text",
        value: "Load More",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Load More button text",
        required: false,
        defaultValue: "Load More",
      },
      {
        fieldName: "load_more_color",
        label: "Load More Text Color",
        value: "#FFFFFF",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter load more text color (e.g., #FFFFFF)",
        required: false,
        defaultValue: "#FFFFFF",
      },
      {
        fieldName: "load_more_background_color",
        label: "Load More Background Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter load more background color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "load_more_icon",
        label: "Load More Icon",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload load more icon",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "load_more_icon_alt",
        label: "Load More Icon Alt Text",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter alt text for load more icon",
        required: false,
        defaultValue: "Load more",
      },
    ],
  
    METADATA_FIELDS: [
      {
        header: "Logo",
        fieldName: "meta_logo",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Logo",
      },
      {
        header: "Alt Image",
        fieldName: "meta_alt_image",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Alt Image Text",
      },
      {
        header: "Description",
        fieldName: "meta_description",
        value: "",
        valueType: "string",
        filedType: "TEXT_AREA",
        placeholder: "Enter Description",
      },
      {
        header: "Description Text Color",
        fieldName: "meta_description_text_color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter description text color (e.g., #000000)",
        defaultValue: "#000000",
      },
      {
        header: "Priority",
        fieldName: "meta_priority",
        value: "",
        valueType: "number",
        filedType: "INPUT",
        placeholder: "Enter Priority",
        required: true,
      },
      {
        header: "Status",
        fieldName: "meta_status",
        value: true,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable this item",
        defaultValue: true,
      },
    ]
  };